/*
NOTICE: code in this file comes from Launch Gate LLC 'Base Functions'

Basic library for creating a copy button which copies static text to the users clipboard on click. When the button
is clicked and the content successfully copies, the class 'was-copied' is added to the button.

Usage:
    - add the class 'copy-on-click' to the button
    - set the attribute 'data-copy-content' equal to the string which should be copied to the clipboard
    - to present a message on copy success, set 'data-copy-success' to either 'tooltip' or 'showTarget',
      and set 'data-copy-success-message' to the desired message.
        - data-copy-success="tooltip" will hijack the elements bootstrap tooltip until its hidden,
          at which point the message is replaced with the original title. If the tooltip was not already shown,
          it's displayed for 3 seconds.
        - data-copy-success="showTarget" will fill the message into 'data-copy-success-target'
          show it, then fade out after 3 seconds.
 */
import $ from 'jquery';

$(document).ready(() => {
    function tooltipShown($el) {
        try {
            return $el.data('bs.tooltip').tip.is(':visible');
        } catch (e) {
            return false;
        }
    }

    function showSuccessMessage($el) {
        const strategy = $el.attr('data-copy-success');
        const msg = $el.attr('data-copy-success-message');

        if (msg && strategy === 'tooltip') {
            const originalTooltipContent = $el.attr('data-original-title');
            const tooltipAlreadyShown = tooltipShown($el);

            // Replace the title and show the tooltip. If its already shown, this re-renders its content
            $el.attr('data-original-title', msg).tooltip('show');

            if (!tooltipAlreadyShown) {
                // If the tooltip was NOT already shown, display it for 3 seconds before hiding it, unless
                // the user hovers over the button while the tooltip is still shown. In that case let bootstrap
                // handle the hiding of the tooltip.
                const hideTimeout = setTimeout(() => {
                    $el.tooltip('hide');
                }, 3000);
                $el.one('mouseenter', () => {
                    clearTimeout(hideTimeout);
                });
            }
            // Once the tooltip has been hidden, reset the tooltip content back to its original value
            $el.one('hidden.bs.tooltip', () => {
                $el.attr('data-original-title', originalTooltipContent);
            });
        } else if (msg && strategy === 'showTarget') {
            // Replace the text in either the specified target, or the element itself if a target was not specified
            const $target = $($el.attr('data-copy-success-target'));
            $target.text(msg).show().css('display', '');
            setTimeout(() => {
                $target.fadeOut();
            }, 3000);
        }
    }

    $('.copy-on-click[data-copy-content]').click(event => {
        event.preventDefault();

        const $el = $(event.currentTarget);
        navigator.clipboard.writeText($el.attr('data-copy-content')).then(() => {
            $el.addClass('was-copied');
            showSuccessMessage($el);
        });
    });
});
